import React from "react"
import { Link } from "gatsby-plugin-intl"
import Layout from "../components/Layout"
import Header from "../components/Header"
import Footer from "../components/Footer"
import CallToAction from "../components/CallToAction"
import Head from "../components/Head"

const PrivacyPolicy = () => {
    return (
        <Layout>
            <Head title="Terms of use - Muun" description="" />
            <div className="page terms-and-conditions">
                <Header className="light" />
                <div className="content container">
                    <h1>Terms of Use</h1>
                    <div className="row">
                        <div className="col-lg-8">
                            <p>
                                Muun Wallet Inc., a company incorporated in the Cayman Islands ("Muun" and/or "We"), provides a self-custodial wallet software for bitcoin and lightning to its users (the "Users" and/or "You") through its mobile application Muun (the "Services") and publishes information regarding the Services on its website <a href="https://muun.com" target="_blank" rel="noopener noreferrer">https://muun.com</a> (the "Site"). By using the Services, you agree to these terms of use (the "Terms") which describe how the Services work and the framework that governs our relationship.
                            </p>

                            <h3>Acceptable Use</h3>
                            <p>
                                Muun's mission is to make self-custody accessible to everyone on the planet. With Muun, you can store, send and receive bitcoins directly on supported blockchain networks. You have full control of your bitcoins, without giving that control to anyone else. Since you are in control, you are also responsible for ensuring that your use of our Services complies with applicable laws and regulations. We may suspend or restrict access if we reasonably believe the Services are being misused.
                            </p>

                            <h3>Intellectual Property and Brand</h3>
                            <p>
                                Muun's software is open source and available under the open-source licenses published in our repositories. Those licenses explain what You can and cannot do with the source code.
                            </p>
                            <p>
                                Muun's name, logos, branding, Site, app design and related content ("Muun Materials") belong to us or our licensors and are protected by intellectual property laws.
                            </p>
                            <p>
                                <strong>Official version.</strong> The only official Muun wallet is the one distributed by us through the official app stores. We do not control, endorse or take responsibility for third-party forks, modified versions or copies of the software, even if they are built from our open-source code or use a similar name or branding. Using those versions is entirely at the User's risk.
                            </p>
                            <p>
                                If You're ever unsure of which version is the official one, please don't hesitate to contact our support team.
                            </p>

                            <h3>Warranty Disclaimer</h3>
                            <p>
                                Muun provides the Services "as is" and "as available", without promises or guarantees. We don't guarantee that the Services will always work perfectly, be uninterrupted, secure, or free of bugs. Blockchain networks are experimental and constantly evolving, and things can go wrong. To the fullest extent permitted by law, We don't make any warranties, express or implied, about the Services.
                            </p>

                            <h3>Limitation on Liability</h3>
                            <p>
                                Muun is a self-custodial wallet. We don't hold your bitcoin and We don't control the Bitcoin or Lightning networks. Because of that, some risks are simply outside Muun's control.
                            </p>
                            <p>
                                For that reason, We can't take responsibility for losses caused by:
                            </p>
                            <ul>
                                <li>The Bitcoin or Lightning networks (delays, outages, forks, congestion, protocol changes),</li>
                                <li>Your device, software or internet connection,</li>
                                <li>Bugs or security issues in the software,</li>
                                <li>Third-party attacks (phishing, malware, hacking, SIM-swaps),</li>
                                <li>Loss or compromise of your private keys or emergency kit, or</li>
                                <li>User mistakes (wrong addresses, wrong amounts, forgotten passwords, transactions are irreversible).</li>
                            </ul>
                            <p>
                                The Services may interact with blockchain networks or third party providers. We do not control them and are not responsible for their performance, availability or security.
                            </p>
                            <p>
                                Beyond this, please keep in mind that Muun's support team is always available to help and answer your questions.
                            </p>
                            <p>
                                To the fullest extent permitted by law, We are not liable for indirect or consequential damages, and Muun's total liability will not exceed USD 100. Nothing here limits liability that cannot legally be limited.
                            </p>

                            <h3>Initial Dispute Resolution</h3>
                            <p>
                                If something isn't working or You have a concern, please contact Muun first. We'll do our best to resolve it together, in good faith. Before starting arbitration or going to court, you agree to give us a reasonable opportunity to try to fix the issue.
                            </p>

                            <h3>Binding Arbitration</h3>
                            <p>
                                If We can't resolve a dispute through the friendly process above within 30 business days, You and Muun agree to resolve it through binding arbitration, instead of going to court.
                            </p>
                            <p>
                                Arbitration will be administered by the International Chamber of Commerce (ICC) under its arbitration rules, by a single arbitrator. The arbitration will be seated in the Cayman Islands (or another location we both agree on). The arbitrator's decision will be final and enforceable. Arbitration will be conducted on an individual basis and in English.
                            </p>

                            <h3>Class Action Waiver</h3>
                            <p>
                                You and Muun agree to bring any claims against each other only on an individual basis, and not as part of any class, collective or representative action. This means You can't bring a claim as part of a group or class action, and neither can We. If a court or arbitrator finds that this class action waiver is not enforceable, then the arbitration section above will not apply.
                            </p>

                            <h3>Governing Law</h3>
                            <p>
                                These Terms are governed by the laws of the Cayman Islands. If a dispute is not subject to arbitration, You and Muun agree that it will be resolved exclusively in the courts of the Cayman Islands. You agree that We may notify You and serve legal notices by email or other reasonable electronic means.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <CallToAction className="d-none d-md-block" />
            <Footer />
        </Layout>
    )
}

export default PrivacyPolicy
